import { sxVariants } from '@/utils/combineSx';

const BUTTON_TRANSITION = 'all 0.2s var(--ease-move)' as const;

const buttonVariants = sxVariants({
  base: theme => ({
    padding: '0.5rem 1rem',
    fontSize: theme.fontSizes.smaller,
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
    transition: BUTTON_TRANSITION,
  }),
  variants: {
    variant: {
      outlined: theme => ({
        fontWeight: 500,
        borderColor: theme.palette.baseColors.deepSeaNavy.c100,
        color: theme.palette.baseColors.deepSeaNavy.c100,
        backgroundColor: theme.palette.baseColors.white.c100,
        '&:hover': {
          borderColor: theme.palette.baseColors.deepSeaNavy.c100,
          backgroundColor: theme.palette.baseColors.deepSeaNavy.c25,
          transform: 'translateY(-1px)',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        },
        '&:disabled': {
          borderColor: theme.palette.baseColors.iceBlue.c100,
          color: theme.palette.text.disabled,
          backgroundColor: theme.palette.baseColors.cloudGray.c25,
        },
      }),
      containedPrimary: theme => ({
        fontWeight: 600,
        backgroundColor: theme.palette.baseColors.fireOrange.c100,
        color: theme.palette.baseColors.white.c100,
        border: 'none',
        '&:hover': {
          backgroundColor: theme.palette.baseColors.fireOrange.c75,
          transform: 'translateY(-1px)',
          boxShadow: '0 4px 8px rgba(255, 98, 80, 0.25)',
        },
        '&:disabled': {
          backgroundColor: theme.palette.baseColors.cloudGray.c100,
          color: theme.palette.text.disabled,
        },
      }),
    },
  },
});

export { buttonVariants, BUTTON_TRANSITION };
